module.exports = __webpack_public_path__ + "img/testimonial-user-1.665f110b.svg";